<button
  mat-icon-button
  (click)="navigateTo(-1, 'previous_button')"
  [disabled]="shouldDisablePrevious$ | async"
>
  <mat-icon class="material-symbols-outlined">navigate_before</mat-icon>
</button>
<button
  mat-icon-button
  (click)="navigateTo(1, 'next_button')"
  [disabled]="shouldDisableNext$ | async"
>
  <mat-icon class="material-symbols-outlined">navigate_next</mat-icon>
</button>
